import SleepyBara from "images/icons/sleepy-bara-outline.svg";
import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { useContentAccess } from "utils/hooks/useContentAccess";

export const EmptyHistory = () => {
  const { t } = useTranslation(["history"]);
  const { tutoringVisible } = useContentAccess();

  return (
    <div className="d-flex justify-content-center align-items-center h-100 flex-column gap-4px text-gray-600">
      <SleepyBara />
      <h2 className="text-gray-600">{t("emptyHistory.title")}</h2>
      <div>
        <Trans
          i18nKey="emptyHistory.description"
          ns="history"
          // AIDEV-NOTE: Maturant doučování nemá — odkaz by ho poslal na `/doucovani`, odkud ho
          // guard vrátí na nástěnku. Věta zůstává doslova stejná, jen bez odkazu: jiný cíl
          // (třeba `/ulohy`) by byl nový produktový nápad, který nikdo nezadal. [TD-351]
          components={{ a: tutoringVisible ? <Link to="/doucovani" className="text-gray-600" /> : <span /> }}
        />
      </div>
    </div>
  );
};
